module.exports = __webpack_public_path__ + "img/a07.21060e5b.png";